import image1 from '../../assets/images/paper-plane.png';
import image2 from '../../assets/images/plane.png';
import image3 from '../../assets/images/space-ship.png';

export const PriceCardData = [
  {
    image: image1,
    head: 'Basic',
    // list: ['Up to 3 servers', 'Weekly backups', '1 TB', '30 days'],
    list: ['Up to 3 servers', 'Weekly backups', '5 GB', 'If you reach this limit within your backup period, the oldest records will be automatically removed.','30 days'],
    price: '$19.99',
  },
  {
    image: image2,
    head: 'Standard',
    // list: ['Up to 10 servers', 'Daily backups', '5 TB', '60 days'],
    list: ['Up to 10 servers', 'Daily backups', '10 GB', 'If you reach this limit within your backup period, the oldest records will be automatically removed.','60 days'],
    price: '$49.99',
  },
  {
    image: image3,
    head: 'Premium',
    // list: ['Up to 50 servers', 'Hourly backups', '20 TB', '90 days'],
    list: ['Up to 50 servers', 'Hourly backups', '15 GB', 'If you reach this limit within your backup period, the oldest records will be automatically removed.', '90 days'],
    price: '$99.99',
  },
];

export const UpdatePlanTexts = {
  create: "You've selected your plan. After confirmation, the subscription fee will be charged. Please confirm your choice to proceed with the subscription.",
  update: "You've selected to upgrade your plan. The difference in the amount will be charged during your next payment. Please confirm your choice to proceed with the upgrade.",
  upgrade:
    "You've selected to switch to a different plan. Your current plan will continue until the end of the current billing period. After that, your subscription will renew with the updated plan. Please confirm your choice to proceed with the change.",
};
